import { useState } from 'react'

const ReadMore = ({children}) => {

  const text = children;
  const [isOpen, setIsOpen] = useState(false);

  const toggleReadmore = () => {
    setIsOpen(!isOpen);
  }

  return (
    <div className="transition ease-in-out delay-150">
      {isOpen || text.length <= 300 ? text : text.slice(0, 300) + "..."}
      {text.length > 300 &&
        <p onClick={toggleReadmore} className="cursor-pointer mt-2 underline">
          {isOpen ? "Read Less" : "Read More"}
        </p>
      }
    </div>
  )
}

export default ReadMore;
